var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M47,10H3c-1.104,0-2,0.896-2,2v32c0,1.104,0.896,2,2,2h44c1.104,0,2-0.896,2-2V12C49,10.896,48.104,10,47,10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M1 27c0 1.104.896 2 2 2h44c1.104 0 2-.896 2-2M32 9V6c0-1.104-.896-2-2-2H20c-1.104 0-2 .896-2 2v3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 22A2 2 0 1 0 25 26A2 2 0 1 0 25 22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.0aae0bd07f9a234bcb176d31f42fd8f2.svg";
export { ForwardRef as ReactComponent };